/** Escape `%`, `_`, `\` for SQL LIKE / PostgREST `ilike` inner text (before wrapping in `%`). */
export function escapeIlikePattern(raw: string): string {
  return raw.replace(/\\/g, "\\\\").replace(/%/g, "\\%").replace(/_/g, "\\_");
}

function quotePostgrestLikeValue(likePattern: string): string {
  return `"${likePattern.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}

/**
 * PostgREST `.or(...)` body: same `ilike` pattern on several columns.
 * Values are double-quoted so commas / special chars in the search string cannot break the filter.
 */
export function buildOrIlikeClause(columns: readonly string[], rawSearch: string): string {
  const t = rawSearch.trim();
  if (!t || columns.length === 0) return "";
  const inner = escapeIlikePattern(t);
  const likePattern = `%${inner}%`;
  const quoted = quotePostgrestLikeValue(likePattern);
  return columns.map((c) => `${c}.ilike.${quoted}`).join(",");
}
